import CookieUtils from 'PyzShopUi/scripts/utils/cookieUtils';
import i18next from 'i18next';
import MiddlewareEventBus from 'PyzShopUi/scripts/react/common/lib/MiddlewareEventBus';
import { IToastPayload } from 'PyzShopUi/scripts/interfaces/IToastPayload';
import { EToastEvents } from 'PyzShopUi/scripts/modules/events/toastEvent';
import {
    ACCEPTANCE_COOKIE_NAME
} from '../../../../../../CookieNoticeWidget/Theme/default/components/molecules/cookie-notice/cookie-notice';

export const RESET_NODE_ID = 'cookie-notice-reset';
const ETRACKER_CONSENT_OVERLAY_ID = 'et-consent-overlay';

export const addCookieNoticeResetListener = () => {
    const cookieNoticeResetNodes = document.querySelectorAll(`#${RESET_NODE_ID}`);
    const middlewareEvenBusInstance = MiddlewareEventBus.getInstance();

    if (!cookieNoticeResetNodes) {
        return;
    }

    cookieNoticeResetNodes.forEach((node) =>
        node.addEventListener('click', (event): void => {
            event.preventDefault();

            const eTrackerConsentOverlayElement = document.getElementById(ETRACKER_CONSENT_OVERLAY_ID);
            // Only trigger the opt-in if it is NOT currently displaying
            if (eTrackerConsentOverlayElement) {
                return;
            }

            CookieUtils.removeCookie(ACCEPTANCE_COOKIE_NAME);
            window._etracker.disableCookies();
            document.cookie = 'et_oi_services=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

            const toastPayload: IToastPayload = {
                message: i18next.t('Thank you! You have successfully opted out of the use of cookies.', {ns: 'customer'}),
                iconClass: 'icon-info',
            };
            middlewareEvenBusInstance.publish({type: EToastEvents.TOAST_FADE_IN, payload: toastPayload});

            setTimeout((): void => {
                if (typeof window.et_showOptIn === 'function') {
                    window.et_showOptIn();
                }
            }, 900);
        })
    );
};
